// extracted by mini-css-extract-plugin
export default {"tabsContainer":"b8MG6d","tabs":"duKcHz","active-gold-50":"ao99WO","active-white":"pH9uq7"};